import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ToastService } from "mis-crystal-design-system/toast";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { ConfigurationService } from "../../../services/configuration.service";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { BookingDataService } from "../../../services/booking-data.service";
import { AsyncWidget } from "mis-crystal-design-system/widgets";
import { WidgetService } from "../../../services/widget.service";
import { ApiService } from "../../../services/api.service";
import * as moment from "moment";

@Component({
  selector: 'mis-employee-web-exp-meal-feedback-card',
  templateUrl: './meal-feedback-card.component.html',
  styleUrls: ['./meal-feedback-card.component.scss']
})
export class MealFeedbackCardComponent implements OnInit {

  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  @Input() list;
  @Input() emptyMessage: string;
  @Input() dateFormat;
  @Input() timeFormat;
  @Output() action = new EventEmitter();
  @Input() scrollToPaginate = false;
  @Input() showAll = false;
  @Input() singleShiftOperation = false;
  isShuttleRequired: boolean = false;
  showCancellationFilter: boolean = false;
  xhrStatus: "DONE" | "LOADING" | "FAILED" = "DONE";
  @Input() widgetControl: AsyncWidget<NsEmpWebExpData.IList[]>;
  // @Input() filterOut: NsEmpWebExpData.IBookingDetailDTOS;
  expanded = false;
  listEnd = 3;

  constructor(
    public configSvc: ConfigurationService,
    private bookingSvc: BookingDataService,
    private cdr: ChangeDetectorRef,
    private toasts: ToastService,
    private widgetSvc: WidgetService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.configSvc.bookingConfigurations.subscribe(res => {
      this.isShuttleRequired = res.isShuttleRequired;
    });
    this.configSvc.configurations.subscribe(res => {
      this.showCancellationFilter = res?.flattenedSettings?.showBookingFilter;
    });
  }

  ngOnDestroy(): void {
  }

  handleAction(event) {
    this.action.emit(event);
  }

  filterBookingList(data){
    const filteredArray = !!data && data.length>0 ? data.filter((obj: any) => {
      return obj.booking.additionalBookings.some(additional => {
        return additional.premiseType === 'MEALS' && !!additional.extras.mealData && additional.extras.mealData.length > 0 
      });
    }) : [];
    data = !!filteredArray && filteredArray.length>0 ? filteredArray.filter((item) => {
      const endTime = moment(item.time.endTime).tz(item.time.timezone);
      const curTime = moment().tz(item.time.timezone)
      return item?.bookingRequestType === 'OFFICE' && endTime.isBefore(curTime)
    }) : [];
    return data.reverse().slice(0, this.listEnd);
  }

}
